import { BydReportFileInterface } from '../interfaces/byd-report-file.interface';

export class BydReportFile {
  /**
   * File uuid
   */
  uuid: string;

  /**
   * File name
   */
  name: string;

  /**
   * @param data File data.
   */
  constructor(data: BydReportFileInterface) {
    if (data) {
      this.uuid = data.uuid;
      this.name = data.name;
    }
  }
}
